import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Car, CheckCircle } from "@phosphor-icons/react";

export function ValidationForm({ onSubmit, submitting }) {
  const [roomNumber, setRoomNumber] = useState("");
  const [carPlate, setCarPlate] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!roomNumber.trim() || !carPlate.trim()) return;
    onSubmit({
      room_number: roomNumber.trim(),
      car_plate: carPlate.trim().toUpperCase(),
    });
    setRoomNumber("");
    setCarPlate("");
  };

  return (
    <Card className="bg-[#121212] border-[#262626] rounded-sm shadow-none">
      <CardHeader className="pb-3">
        <CardTitle className="font-heading text-lg font-semibold text-white flex items-center gap-2">
          <Car size={20} weight="bold" className="text-[#007AFF]" />
          VALIDATE CAR
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3]">Room Number</Label>
            <Input
              data-testid="room-number-input"
              value={roomNumber}
              onChange={(e) => setRoomNumber(e.target.value)}
              placeholder="Room Number"
              required
              className="bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] focus:ring-1 focus:ring-[#007AFF] text-white placeholder:text-[#737373] rounded-sm font-mono-data"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3]">Car Plate</Label>
            <Input
              data-testid="car-plate-input"
              value={carPlate}
              onChange={(e) => setCarPlate(e.target.value.toUpperCase())}
              placeholder="e.g. ABC1234"
              required
              className="bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] focus:ring-1 focus:ring-[#007AFF] text-white placeholder:text-[#737373] rounded-sm font-mono-data text-lg tracking-wider"
            />
          </div>
          <Button
            data-testid="validate-btn"
            type="submit"
            disabled={submitting}
            className="w-full bg-[#007AFF] hover:bg-[#3395FF] text-white font-semibold rounded-sm h-11 text-sm uppercase tracking-wider transition-all duration-200"
          >
            {submitting ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <CheckCircle size={18} weight="bold" className="mr-1" />
                VALIDATE
              </>
            )}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
